module.exports = __webpack_public_path__ + "static/img/2_v2.4e3c0878.png";